<script>
import i18n from "../../dashboard/i18n";

export default {
  name: "PricingBox",
  props: {
    trial_used: {
      type: Boolean,
      default: true
    },
    linklabel: {
      type: String,
      default: gettext("Get started with")
    },
    showbutton: {
      type: Boolean,
      default: true
    },
    instant_checkout: {
      type: Boolean,
      default: false
    },
    linkpath: {
      type: String,
      default: 'registration/'
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      feature_sections: {
        'MAIN': '',
        'QUALITY': gettext('Quality'),
        'LIVESTREAMING': gettext('Live streaming options'),
        'SAVING': gettext('Saving to your device'),
        'ADS': gettext('Ads'),
        'OTHER': gettext('Other'),
      }
    }
  },
  methods: {
    interpolate(text) {
      if (!text) return text;
      return text.replace(/\[(.+?)\]/g, (full, key) => {
        return this.data[key] !== undefined ? this.data[key] : full;
      });
    }
  },
}
</script>


<template>
    <article class="h-100 transition" v-if="!data.hidden" :class="{ 'livegreen': data.interval === 'one-time' }">
        <div class="pricing-box-header border-bottom">
            <div>
                <h3 class="fw-semibold primary-c">
                    {{ data.plan_name }}
                </h3>

                <p>{{ data.description ? gettext(data.description) : data.description }}</p>

                <span class="fw-semibold text-grey">
                  <span class="price primary-c">{{ data.currency_symbol }}{{ data.monthly_price }}</span>
                  /{{ data.interval === 'one-time' ? gettext('purchase') : gettext('month') }}
                </span>

                <p v-if="data.monthly_price <= 0">{{ gettext("Free for everyone") }}</p>
                <p v-else-if="data.interval === 'one-time' && data.plan_games > 0">{{ gettext("Once your subscription games are depleted, these games will be used instead. Use anytime, never expires.") }}</p>
                <p v-else-if="data.interval === 'one-time'">{{ gettext("Use anytime, never expires") }}</p>
                <p v-else-if="data.interval === 'month'">{{ gettext("Billed monthly") }}</p>
                <p v-else><strong>{{data.currency_symbol}}{{data.amount / 100}}</strong> {{ gettext("billed yearly") }}</p>

                <BaseButton v-if="data.interval === 'one-time' && showbutton"
                    :ga-event="`pricing_${data.interval_count}_${data.plan_name}`"
                    :to="`billing-information/${data.id}/`"
                    class="d-block text-center mt-1 subs-pink-but"
                    type="btn-primary"
                    >{{ gettext("Select Quantity & Buy") }}</BaseButton>
                <BaseButton v-else-if="data.trial && showbutton && !trial_used"
                    :ga-event="`pricing_${data.interval_count}_${data.plan_name}`"
                    :to="$auth_status && $auth_status.authenticated_broadcaster
                      ? '/dashboard/upgrade'
                      : ($auth_status && $auth_status.authenticated_viewer_only
                          ? (data.monthly_price > 0 ? `/registration/viewer/${data.id}/` : '/registration/viewer')
                          : (data.monthly_price > 0
                              ? `${linkpath}${data.id}/`
                              : `${linkpath}`
                            )
                        )"
                    class="d-block text-center mt-1 subs-pink-but"
                    type="btn-primary"
                    >{{ gettext("Start Free Trial") }}</BaseButton>
                <BaseButton v-else-if="showbutton"
                    :ga-event="`pricing_${data.interval_count}_${data.plan_name}`"
                    :to="$auth_status && $auth_status.authenticated_broadcaster
                      ? '/dashboard/upgrade'
                      : ($auth_status && $auth_status.authenticated_viewer_only
                          ? (data.monthly_price > 0 ? `/registration/viewer/${data.id}/` : '/registration/viewer')
                          : (data.monthly_price > 0
                              ? `${linkpath}${data.id}/`
                              : `${linkpath}`
                            )
                        )"
                    class="d-block text-center mt-1 subs-pink-but"
                    type="btn-primary"
                    >{{gettext(linklabel)}} {{ data.plan_name }}</BaseButton>
                      <p v-if="data.trial && showbutton && !trial_used" class="text-center">{{ gettext("for") }} <strong> {{data.trial}} </strong> {{ gettext("days") }}</p>
            </div>
        </div>

        <div class="pricing-box-body">
            <div
                v-for="(value, key, index2) in feature_sections"
                v-if="data.features.filter(f => f.feature_section === key).length > 0"
                :key="`other-b${index2}`"
                :class="{ 'plan-margin-2': index2 !== feature_sections.length - 1 }"
            >
                <h4 class="fw-semibold" style="margin-bottom: 1rem">{{ value }}</h4>

                <ul>
                  <li
                        v-for="(benefit, benefitIndex) in data.features.filter(f => f.feature_section === key)"
                        :key="`benefits-${benefitIndex}`"
                        :class="{ disabled: !benefit.is_included }"
                    >
                        <svg
                            v-if="benefit.is_included"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_807_11066)">
                                <path
                                    d="M5.625 9L7.875 11.25L12.375 6.75M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                                    stroke="#FA1F63"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_807_11066">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                        <svg
                            v-else
                            width="19"
                            height="18"
                            viewBox="0 0 19 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.75 6.75L7.25 11.25M7.25 6.75L11.75 11.25M17 9C17 13.1421 13.6421 16.5 9.5 16.5C5.35786 16.5 2 13.1421 2 9C2 4.85786 5.35786 1.5 9.5 1.5C13.6421 1.5 17 4.85786 17 9Z"
                                stroke="#161616"
                                stroke-opacity="0.25"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>

                        <span class="featlabel" v-html="interpolate(benefit.short_description ? gettext(benefit.short_description) : benefit.short_description)"></span>
                      <small v-if="benefit.long_description" v-html="interpolate(gettext(benefit.long_description))"></small>
                    </li>
                </ul>
            </div>
        </div>
    </article>
</template>

<style lang="scss" scoped>
article {
    border-radius: 1rem;
    background-color: var(--global-color-white);
    border: 0.08rem solid transparent;
    overflow: hidden;

    &:hover {
        border-color: rgba(250, 31, 99, 0.6);

        .pricing-box-header:before {
            opacity: 1;
        }
    }
}

.pricing-box-header {
    position: relative;

    & > div {
        position: relative;
        z-index: 2;
    }

    &:before {
        content: '';
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #ffebf1 0%, rgba(255, 255, 255, 0) 100%);
        z-index: 1;
        transition: opacity 0.2s ease;
        opacity: 0;
    }
}

.pricing-box-header,
.pricing-box-body {
    padding: 1.5rem;
}

h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
}

p {
    font-size: 0.8rem;
}

.price {
    font-size: 2.5rem;
}

ul li {
    font-size: 0.8rem;
    color: var(--global-color-grey);
    margin-bottom: 1rem;
    position: relative;
    padding-left: 1.7rem;

    &:last-child {
        margin-bottom: 0;
    }

    &.disabled {
        color: rgba(22, 22, 22, 0.25);
    }

    svg {
        position: absolute;
        top: 0;
        left: 0;
    }
}
::v-deep(.featlabel p) {
  all: unset !important;
}

::v-deep(small p) {
  all: unset !important;
}

h4 {
    text-transform: uppercase;
    font-size: 0.8rem;
    color: #525252;
}

small {
    font-size: 0.75rem;
    color: var(--global-color-grey);
    line-height: 18px;
    margin-left: -27px;
    margin-top: 0.5rem;
    display: block;
}
</style>
